// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
//引入路由
import router from './router'
//引入elementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入http请求
import http from './assets/javascript/http'
//引入vuex进行公共状态管理
import store from './vuex/store'


/*引入饼图包*/
import VePie from 'v-charts/lib/pie.common'
import histogram from 'v-charts/lib/histogram'

Vue.component(VePie.name, VePie)
Vue.component(histogram.name,histogram)
//修改原型链
Vue.config.productionTip = false;
Vue.prototype.$http = http;

//使用elementUI
Vue.use(ElementUI);
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js